import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ResultRow, getGrupoFromMilhar, animalNames } from "./constants";

interface CentenasTabProps {
  filtered: ResultRow[];
}

const CentenasTab: React.FC<CentenasTabProps> = ({ filtered }) => {
  const centenaCount: Record<string, number> = {};
  filtered.forEach(r => {
    const cent = r.milhar.slice(-3);
    centenaCount[cent] = (centenaCount[cent] || 0) + 1;
  });

  const centenaTop = Object.entries(centenaCount)
    .map(([cent, count]) => ({ centena: cent, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 20);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Centenas Mais Frequentes (Top 20)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 sm:gap-3">
          {centenaTop.map((c) => {
            const grupo = getGrupoFromMilhar(c.centena);
            return (
              <div key={c.centena} className="flex flex-col p-3 rounded-lg border bg-card gap-1">
                <div className="flex items-center justify-between">
                  <span className="font-mono font-bold text-lg">{c.centena}</span>
                  <span className="text-sm text-muted-foreground bg-muted px-2 py-1 rounded-full">
                    {c.count}x
                  </span>
                </div>
                <span className="text-xs text-muted-foreground">
                  G{String(grupo).padStart(2, '0')} {animalNames[grupo] || ''}
                </span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default CentenasTab;
